import React from 'react';
import { Box, Button } from '@mui/material';
import { PlayArrow } from '@mui/icons-material';

interface RightsTransferButtonsProps {
  selectedAvailableRights: string[];
  selectedAssignedRights: string[];
  onMoveToAssigned: () => void;
  onMoveToAvailable: () => void;
}

const RightsTransferButtons: React.FC<RightsTransferButtonsProps> = ({
  selectedAvailableRights,
  selectedAssignedRights,
  onMoveToAssigned,
  onMoveToAvailable,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2 }}>
      <Button
        variant="contained"
        onClick={onMoveToAssigned}
        disabled={selectedAvailableRights.length === 0}
        sx={{ minWidth: '40px', p: '6px', bgcolor: (theme) => theme.palette.custom.buttonBackground }}
      >
        <PlayArrow sx={{ color: 'white' }} />
      </Button>
      <Button
        variant="contained"
        onClick={onMoveToAvailable}
        disabled={selectedAssignedRights.length === 0}
        sx={{ minWidth: '40px', p: '6px', bgcolor: (theme) => theme.palette.custom.buttonBackground }}
      >
        <PlayArrow sx={{ color: 'white', transform: 'rotate(180deg)' }} />
      </Button>
    </Box>
  );
};

export default RightsTransferButtons;